module.exports = __webpack_public_path__ + "static/media/user-icon.9872f7c5.svg";